/**
 * Environment configuration
 */

/** API Base URL for backend requests */
export const API_BASE_URL = process.env.BUN_PUBLIC_API_BASE_URL || 'http://localhost:8080'

/** LiveKit WebSocket URL */
export const LIVEKIT_URL = process.env.BUN_PUBLIC_LIVEKIT_URL || 'ws://localhost:7880'
